// packages/console/src/api/sources.ts
//
// FT-3 orchestrator client: sources (the upload-decoupled library). A source is
// a landed, probed upload that is not yet turned into a job; the Library lists
// them and can re-stage or delete them. Types mirror the orchestrator's source
// record; mediaInfo reuses the SourceMediaInfo probe type from ./jobs. Sources
// live on the SAME jobs service base as /v1/jobs, so this reuses servicePaths.jobs.

import { servicePaths } from "./config";
import { request } from "./http";
import type { SourceMediaInfo } from "./jobs";

// Source is a landed + probed upload (GET /v1/sources), workspace-scoped by the
// same bearer auth as every other route. sha256 is the source's content hash,
// used as the delete key. mediaInfo is the orchestrator probe (may be absent on
// a source that has not been probed yet).
export interface Source {
  objectKey: string;
  workspaceId: string;
  sha256: string;
  filename: string;
  sizeBytes: number;
  mime: string;
  mediaInfo?: SourceMediaInfo;
  probedAt: string;
}

const j = servicePaths.jobs;

export function listSources(signal?: AbortSignal): Promise<{ sources: Source[] }> {
  return request<{ sources: Source[] }>(`${j}/v1/sources`, { signal });
}

// deleteSource removes a landed source by its sha256 (a 64-hex token). The
// server 404s an unknown sha and 400s a non-hex token.
export function deleteSource(sha: string): Promise<unknown> {
  return request<unknown>(`${j}/v1/sources/${encodeURIComponent(sha)}`, { method: "DELETE" });
}
